import React from 'react';

interface SliderCaptionProps {
  title: string;
  description: string;
  isDesktop: boolean;
}

const SliderCaption = ({ title, description, isDesktop }: SliderCaptionProps) => {
  return (
    <div 
      className={`
        absolute bg-black/50 text-white p-6 backdrop-blur-sm
        transition-all duration-700 ease-in-out
        ${isDesktop ? 'bottom-12 left-12' : 'bottom-0 left-0 right-0'}
      `}
      style={{ 
        width: isDesktop ? '732px' : '100%',
        height: 'auto',
        minHeight: isDesktop ? '181px' : 'auto'
      }}
    >
      <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-4 animate-fadeIn">
        {title}
      </h3>
      <p className="text-sm md:text-base animate-slideUp">
        {description}
      </p>
    </div>
  );
};

export default SliderCaption;